import tools from "../../../../../helpers/tools";

function ItemAssignTo(props) {
  return (
    <div className="assignTo d-center font-weight-bold">
      {props.simplifiedFormItem.parameters?.partenaire_lie?.nom_societe}
      {props.simplifiedFormItem.parameters?.client_lie?.firstname &&
        " + " +
          tools.getFullName(
            props.simplifiedFormItem.parameters?.client_lie || {}
          )}
    </div>
  );
}

export default ItemAssignTo;
